import React from 'react';
import { createPortal } from 'react-dom';
import { StorySettingsType } from 'types/story';

type Props = {
	fonts: StorySettingsType['fonts'];
};

const GoogleFonts = (props: Props) => {
	if (!props.fonts || Object.values(props.fonts).length === 0) {
		return null;
	}

	const href = Object.values(props.fonts).reduce((memo, value) => {
		/* eslint-disable no-param-reassign */
		if (value.fontType === 'google') {
			memo += `${!memo ? 'https://fonts.googleapis.com/css?family=' : '|'}${value.url}`;
		}
		/* eslint-enable no-param-reassign */
		return memo;
	}, '');

	if (!href) {
		return null;
	}

	return createPortal(
		<>
			<link rel="preconnect" href="https://fonts.gstatic.com" />
			<link href={href} rel="stylesheet" />
		</>,
		document.head
	);
};

export default GoogleFonts;
